import { useResources } from './useResources'

export default useResources
